// PWA app-icon badge (Badging API) — single helper used across the app so the installed home-screen
// icon reflects the total unread count. No-op where unsupported (in-app unread badges still work).
export function setAppBadge(count) {
  try {
    if (!('setAppBadge' in navigator)) return;
    const n = Number(count) || 0;
    if (n > 0) navigator.setAppBadge(n).catch(() => {});
    else navigator.clearAppBadge().catch(() => {});
  } catch { /* unsupported — ignore */ }
}

export function clearAppBadge() {
  try {
    if ('clearAppBadge' in navigator) navigator.clearAppBadge().catch(() => {});
  } catch { /* ignore */ }
}

// Keep BOTH the Badging API (desktop / iOS 16.4+) AND the service worker in sync with the ONE canonical
// unread count. On Android the Badging API is unsupported, so the launcher dot is driven by active
// system-tray notifications: we hand the count to the SW so that when unread reaches 0 it closes the
// tray notifications, clearing the OS launcher dot in step with the real unread state. No second counter.
export function syncBadge(count) {
  const n = Number(count) || 0;
  setAppBadge(n); // desktop / iOS where supported (no-op on Android)
  try {
    const sw = navigator.serviceWorker;
    if (!sw) return;
    const hidden = (typeof document !== 'undefined' && document.visibilityState === 'hidden');
    const msg = { type: 'sync-badge', unread: n, hidden };
    const post = (target) => { try { if (target) target.postMessage(msg); } catch { /* ignore */ } };
    if (sw.controller) post(sw.controller);
    else sw.ready.then((reg) => post(reg.active)).catch(() => {});
  } catch { /* ignore */ }
}
